import Address from '@/domain/model/business/Address.ts';
import { isAfter } from 'date-fns'; // noinspection JSUnresolvedVariable

// noinspection JSUnresolvedVariable
export default class Plant {
  constructor(
    public jsonData: any,
    public readonly id: number,
    public name: string,
    public plantCode: string,
    public timeZone: string,
    public monitoredSince: string,
    public owningCompanyId: number,
    public weatherStationId: number,
    public yieldScore7d: number,
    public yieldScore30d: number,
    public address: Address,
  ) {
    this.jsonData = jsonData;

    this.id = id;
    this.name = name;
    this.plantCode = plantCode;
    this.timeZone = timeZone;
    this.monitoredSince = monitoredSince;
    this.owningCompanyId = owningCompanyId;
    this.weatherStationId = weatherStationId;
    this.yieldScore7d = yieldScore7d;
    this.yieldScore30d = yieldScore30d;

    this.address = address;
  }

  public static fromJson(jsonData): Plant {
    return new Plant(
      jsonData,
      jsonData.id,
      jsonData.name,
      jsonData.plant_code,
      jsonData.time_zone,
      jsonData.monitored_since,
      jsonData.owning_company_id,
      jsonData.weather_station_id,
      jsonData.yield_score_7d,
      jsonData.yield_score_30d,
      new Address(jsonData.address),
    );
  }

  getJson() {
    return this.jsonData;
  }

  isMonitored() {
    return (
      !('monitored_since' in this.jsonData) ||
      (this.jsonData.monitored_since !== null &&
        isAfter(new Date(), this.getMonitoredSince()))
    );
  }

  isOwningCompany(companyId) {
    return this.jsonData.owning_company_id === companyId;
  }

  getOwningCompanyId() {
    return this.jsonData.owning_company_id;
  }

  getOwningCompanyName() {
    return this.jsonData.companies.find((company) => company.is_owner).name;
  }

  getCompanies() {
    if (!this.jsonData.companies) return [];
    return this.jsonData.companies;
  }

  getName() {
    return this.jsonData.name;
  }

  getId() {
    return this.jsonData.id;
  }

  getPlantcode() {
    return this.jsonData.plant_code;
  }

  getAddress() {
    return new Address(this.jsonData.address);
  }

  getTags() {
    return this.jsonData.tags;
  }

  getYieldScore(decimals = 4) {
    return this.jsonData.yield_score_7d
      ? parseFloat(this.jsonData.yield_score_7d).toFixed(decimals)
      : null;
  }

  getMonitoredSince(): Date {
    return new Date(this.jsonData.monitored_since);
  }

  getCustomFields() {
    return this.jsonData.custom_fields;
  }

  hasMeters(): boolean {
    return this.jsonData.meters && this.jsonData.meters.length > 0;
  }
}
